import { IonIcon, IonSpinner } from '@ionic/react';
import styled, { css } from 'styled-components';
import Page from '../components/Page';
import withNav from '../utils/hoc/withNav';
import cooking from '../assets/Cooking.png';
import { chevronForwardOutline, closeCircleOutline, logoIonic, personCircleOutline } from 'ionicons/icons';
import { IonHeader } from '@ionic/react';
import FoodService from '../services/FoodService';
import { useEffect, useState } from 'react';
import UserService from '../services/UserService';
import { bindActionCreators } from '@reduxjs/toolkit';
import * as FoodActions from '../actions/FoodActions';
import * as XookActions from '../actions/XookActions';
import { setMiscDishData } from '../actions/DishActions';
import { setCart, clearCart } from '../actions/CartActions';
import { setUserData } from '../actions/UserActions';
import { setInitalInventory, updateIngrdientQuantity} from '../actions/InventoryActions';
import { connect } from 'react-redux';
import { DISH_MODES } from '../constants/DishConstants';
import { deepCopy } from '../utils/objects';
import OrderService from '../services/OrderService';
import { QuantityManager } from '../components/QuantityManager';
import { useLocation } from 'react-router-dom';
import ToastService from '../services/ToastService';
import Drawer from '../components/Drawer';
import { renderCustomisations } from '../utils/parsers/customisations';
import { precision, uptilTwoDecimalPlaces } from '../utils/misc';
import { calculateInventory, validateCartItems } from '../utils/parsers/inventory';
import { INVENTORY_UPDATE_ACTION } from '../constants/InventoryConstants';
import TechnicalError from '../components/Error';
import bag from '../assets/Bag.png';
import { SPECIAL_ERRORS } from '../config/error';
import useIsAppOffline from '../utils/hooks/useIsOffline';
import Analytics, { TRACK_PAGE_CATEGORIES } from '../lib/anayltics';
import { Modal, ModalOverlay } from '../components/Modal';
import HistoryService from '../services/HistoryService';
import MilestoneComponent from '../components/Milestone';
import PromoBanner from './MachineLanding/components/PromoBanner';

const Center = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  height:100%;
  width:100%;
`;

const PageHeader = styled(IonHeader)`
    background:${({theme}) => theme.colors.main.background};
    font-family:${({theme}) => theme.fonts.primary};
    font-style: normal;
    font-size:20px;
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    padding:1rem 1rem 0.5rem 1rem;
    border:none;
    box-shadow:none;
    z-index:110;
    &:after {
        background-image:none;
        height:0 !important;
    }
`;

const Header = styled.div`
    margin:2rem 0 0 0;
    text-align:center;
    font-weight: 600;
    font-size: 20px;
    color:#FFF;
    width:100%;
`;

const HeaderSegment1 = styled.div`
    display:flex;
`;

const Logo = styled.img`
    width: 32px;
    height: 32px;
`;

const RestaurantDetails = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    width:100%;
    gap:0.5rem 0;
`;

const RestaurantId = styled.div`
    text-align:left;
    width:100%;
    font-weight: 400;
    font-size: 14px;
    margin:0rem 0 0 0;
    color:#d6d6d6;
`;

const RestaurantLocation = styled.div`
    text-align:left;
    font-weight: 500;
    font-size: 16px;
`;

const SmallLine = styled.div<any>`
    background: #FFCC00;
    height: 3px;
    width: 20px;
`;

const HeaderSegment2 = styled.div`
    display:flex;
    flex-direction:row;
    width:max-content;
`;

const LiveOrder = styled.img`
    width:28px;
    height:28px;
    transform:scale(1.5);
    margin:0 2rem 0 0;
    object-fit:contain;
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
`;

const Account = styled(IonIcon)`
    height:31px;
    width:31px;
    color:#FFF;
`;

const MenuContainer = styled.div`
    display:flex;
    flex-direction:column;
    gap:2rem;
    width:100%;
    height:max-content;
    align-items:center;
`;

const SubMenu = styled.div`
    padding:0 1rem;
    display:flex;
    flex-direction:column;
    height:max-content;
    width:100%;
    position:relative;
`;

const SubMenuHead = styled.div`
    display:flex;
    align-items:center;
    position:sticky;
    top:-1px; //To fix the slight gap that appears in some instances
    width:100%;
    background:${({theme}) => theme.colors.main.background};
    z-index:106;
    padding:1rem 0;
`;

const SubMenuImage = styled.img`
    width:42px;
    height:42px;
`;

const SubMenuDetails = styled.div`
    display:flex;
    flex-direction:column;
    gap:0.5rem 0;
    align-items:flex-start;
    width:100%;
    padding:0 0 0 1rem;
`;

const SubMenuTitle = styled.div`
    font-weight: 700;
    font-size: 21px;
    color: #F2F2F2;

`;

const SubMenuSubtitle = styled.div`
    text-align:left;
    font-weight: 500;
    font-size: 13px;
    color: #a6a6a6;
`;

const Dishes = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    flex-wrap:wrap;
    align-items:center;
    height:max-content;
    width:100%;
    gap:1rem 0.5rem;
`;

const DishCard = styled.div<any>`
    position:relative;
    overflow:hidden;
    background:#4B4B4B;
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    padding:1rem;
    min-height:300px;
    width:48%;
    border-radius:6px;
    ${props => props.hero && css`
        width:100%;
        min-height:277px;
        `
    }
    ${props => (props.isAvailableLater || props.isSoldOut)&& css`
        pointer-events:none;
        &:after {
            content:'';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background:#4b4b4b;
            opacity: .5;
            z-index:104;
        }
    `}
`;

const EmptySpace = styled.div<any>`
    margin:5.4rem 0 0 0;
    ${props => props.hero && css`
       margin:3rem 0 0 0;`
    }
`;

const Tag = styled.div<any>`
    background:${props => props.fill};
    color:${props => props.color};
    width: max-content;
    padding:0.3rem;
    height: 18px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-weight: 500;
    font-size: 10px;
    z-index:101;
`;

const FillerElement = styled.div`
    height:18px;
`;

const DishTitle = styled.div<any>`
    width:100%;
    text-align:left;
    margin:0.6rem 0 0 0;
    color: ${props => props.color};
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    height:40px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    z-index:103;
    ${props => props.hero && css` 
        height:50px;
        width:50%;
        font-weight: 500;
        font-size: min(4.8vw, 20px);
        line-height:25px;`
    }
`; 

const Line = styled.div<any>`
    margin:0.5rem 0 0 0;
    background: ${props => props.fill};
    height: 4px;
    width: 32px;
    ${props => props.hero && css` 
        margin:1rem 0 0 0;
        height:5px;
        width:40px;`
    }
`;

const DishDesc = styled.div<any>`
    width:100%;
    margin:1rem 0 0 0;
    color: ${props => props.color};
    font-weight: 400;
    font-size: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    /* weird webkit bug where it cuts of descendent letters. Added padding to fix it  */
    /* https://stackoverflow.com/questions/63977541/descenders-of-letters-get-cropped-out-when-using-webkit-line-clamp-with-reduced  */
    overflow: hidden;
    text-overflow: ellipsis;
    text-align:left;
    line-height:16px;
    overflow: hidden;
    ${props => props.hero && css`
        -webkit-line-clamp:4; 
        line-height: 20px;
        height: 80px;
        margin:1rem 0 0 0;
        padding-bottom: 0.14em;
        font-size: 14px;`
    }
`;

const DishPricing = styled.div<any>`
    display:flex;
`;

const DishPrice = styled.div<any>`
    color: ${props => props.color};
    font-weight: 500;
    font-size: 16px;
    ${props => props.hero && css` 
        font-size: 21px;`
    }
`;

const DishDiscountedPrice = styled.div<any>`
    font-weight: 400;
    font-size: 12px;
    color: ${props => props.color};
    text-decoration: line-through;
    margin:0.3rem 0 0 0.5rem;
    ${props => props.hero && css` 
        font-size: 14px;`
    }
`;

const DishImage = styled.img<any>`
    position: absolute;
    filter: drop-shadow(-16px 8px 0px ${props => props.shadow});
    width: 150.26px;
    height: 150.26px;
    right: -15px;
    top: -48px;
    ${props => props.hero && css`
        width: 284px;
        height: 285px;
        right: -85px;
        top: -110px;
        filter: drop-shadow(-20px 10px 0px ${props.shadow});
    `};
    ${props => props.isAvailableLater && css`
        filter: grayscale(100%) drop-shadow(-16px 8px 0px ${props.shadow});
    `}
    ${props => props.isSoldOut && css`
        filter: grayscale(100%) drop-shadow(-16px 8px 0px ${props.shadow});
        opacity:0.8;
    `}
`;

const DishFooter = styled.div<any>`
    margin-top:26px;
    height:25px;
    width:100%;
    display:flex;
    justify-content:space-between;
    align-items:center;
    ${props => props.hero && css`
        margin-top: 1.3rem;
    `}
`;

const DishCount = styled.div<any>`
    width: 25px;
    height: 25px;
    border-radius:50%;
    color:${props => props.fillText};
    background:#909090;
    display:flex;
    justify-content:center;
    align-items:center;
    font-weight: 500;
    font-size: 15px;
    color:#FFF;
    ${props => props.hero && css`
        width: 30px;
        height: 30px;
    `}
`;

const SoldOutMessage = styled.div`
    margin:0 0 6px 0px;
    text-align:right;
    color:#F57676;
    font-size:14px;
    font-weight:500;
    z-index:105;
    margin-top:auto;
`;

const NextAvailableMessage = styled.div<any>`
    width:100%;
    text-align:left;
    font-weight: 400;
    font-size: 12px;
    color:${props => props.color};
    z-index:106;
`;

const CartFloater = styled.div`
    display:flex;
    position:absolute;
    bottom:3rem;
    min-width:120px;
    min-height: 52px;
    border-radius:25px;
    background:#FFCC00;
    color:#000;
    box-shadow: 0px 0px 40px 15px rgba(0, 0, 0, 0.2);
    z-index:110;
`;

const CartContent = styled.div`
    position:relative;
    width:100%;
    display:flex;
    justify-content:space-evenly;
    align-items:center;
    margin:auto;
`;

const CartIconWrapper = styled.div`
    position:relative;
    height:28px;
    width:28px;
`

const CartIcon = styled.img`
    transform:scale(1.4);
    margin-top:-4px;
`;

const CartCount = styled.div`
    position:absolute;
    bottom:5px;
    left:10.75px;
    margin:0 auto;
    font-size:14px;
`;

const CartPrice = styled.div`
    font-weight: 500;
    font-size: 18px;
    font-family: Roboto;
`;

const DrawerHeader = styled.span`
    font-weight: 600;
    font-size: 20px;
    color: #F2F2F2;
    text-align:left;
`;

const DrawerSubHeader = styled.span`
    font-weight: 500;
    font-size: 16px;
    color: #E2E2E2;
    margin:1rem 0 0 0;
    text-align:left;
`;

const DrawerDishComponent = styled.div<any>`
    margin:1rem 0 0 0;
    display:flex;
    align-self:stretch;
    height:max-content;
    min-height:7rem;
    padding:1rem;
    color:#F2F2F2;
    background:#737373;
    border-radius: 6px;
    ${props => props.disabled && css`
        opacity: 0.7;
    `};
`;

const DishIndex = styled.div`
    padding:0 0.5rem 0 0;
    font-size:14px;
`;

const DishData = styled.div`
    display:flex;
    flex-direction:column;
    width:100%;
    min-width:0;
    padding:0 0.5rem 0 0;
    gap:1rem 0;
`;

const DishColumn = styled.div`
    display:flex;
    flex-direction:column;
    align-items:flex-end;
    width:max-content;
`;

const CustomizeLink = styled.div`
    margin:auto 0 5px 0;
    font-weight: 600;
    font-size: 15px;
    text-decoration: underline;
    color: #E8E8E8;
    text-align:left;
`;

const DrawerDishPricing = styled.div`
    margin:auto 0 0 0;
    display:flex;
    flex-direction:row;
    align-items:center;
    color: #E8E8E8;
    font-size: 16px;
    font-weight: 700;
    line-height: normal;
    width:max-content;
    height:max-content;
    align-self:flex-end;
`;

const DiscountedPrice = styled.div<any>`
    font-weight: 400;
    font-size: 14px;
    color: #F2F2F2;
    text-decoration: line-through;
`;


const DrawerButtonGroup = styled.div`
    margin:1rem 0 0 0;
    display:flex;
    flex-direction:row;
    justify-content:flex-end;
`;

const DrawerButton = styled.button`
    display:flex;
    align-items:center;
    justify-content:center;
    background: #FFCC00;
    border-radius: 4px;
    width: 105px;
    height: 36px;
    font-weight: 500;
    font-size: 13px;
    text-transform: uppercase;
    color: #383838;
`;

const Overlay = styled.div`
    position:absolute;
    top:0;
    bottom:0;
    margin:0;
    left:0;
    width:100%;
`;

const OverlayContent = styled.div`
    display:flex;
    flex-direction:column;
    gap:1rem;
    padding:1rem;
    height:100%;
`;

const Row = styled.div`
    display:flex;
    flex-direction:row;
    width:100%;
    justify-content:space-between;
`;

const SecondaryCTA = styled.div<any>`
	width: 100%;
	border-radius: 4px;
	background: #000;
    color:#F2f2f2;
	z-index: 105;
    padding:1rem;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    margin:0 0 0.5rem 0;
`;

const ActiveOrderText = styled.div`
    display:flex;
    align-items:center;
    flex-direction:row;
    color:#FF7676;
    font-size:13px;
    font-weight:500;
`;

const TrackOrderText = styled.div`
    display:flex;
    align-items:center;
    flex-direction:row;
    color:#FFFFFF;
    font-size:13px;
    font-weight:400;
`;

const InstallCTA = styled.div`
    background:#FFFFFF;
    color:#000;
    height:max-content;
    width:max-content;
    padding:0.5rem;
    font-size:14px;
    font-weight:400;
    border-radius:15px;
    margin-right:15px;
`;

const DishStates = {
    AVAILABLE : "available",
    AVAILABLE_LATER : "availableLater",
    SOLD_OUT : "soldOut",
}
  
const DishCardColors = {
    [DishStates.AVAILABLE]: {
        background:"#4B4B4B",
        primaryText:"#E8E8E8",
        secondaryText:"#C1C1C1",
        fill:"#909090",
        fillText:"#373737",
        secondaryFill:"#FFCC00",
        secondaryFillText:"#000",
        shadow:"#282828",
    },
    [DishStates.AVAILABLE_LATER]: {
        background:"#4B4B4B",
        primaryText:"#6A6A6A",
        secondaryText:"#6A6A6A",
        fill:"#636363",
        fillText:"#373737",
        secondaryFill:"#828282",
        secondaryFillText:"#000",
        shadow:"#232222",
    },
    [DishStates.SOLD_OUT]: {
        background:"#4B4B4B",
        primaryText:"#6A6A6A",
        secondaryText:"#6A6A6A",
        fill:"#636363",
        fillText:"#373737",
        secondaryFill:"#828282",
        secondaryFillText:"#000",
        shadow:"#232222",
    }
};

const ReplenishmentMessage = styled.div`
    margin:0.5rem 0;
    min-height:60px;
    width:100%;
    display:flex;
    align-items:center;
    text-align:left;
    padding:0 1rem;
    line-height:18px;
    color:#FFF;
    background:#22AEA6;
`;

const cartAddDisabledError = "We regret to inform you that we currently do not have enough stock to fulfill your request. Please consider adjusting the quantity or try again later.";

const MachineLanding = (props:any) => {
    
    //Redux States

    const { Food, Xook, Cart, Inventory, User } = props;

    const { menuData, brandDetails, dishDetails, dishesDataDynamic, nextAvailableSlots, ingredientDetails, recipesMap } = Food;

    const { xookId, xookLocation, maxItemsPerOrder, dataLoaded, hasActiveReplenishment, currency } = Xook;

    const { itemsCount, cartItems, invalidCartItems, offeredCartPrice, cartPrice } = Cart;

    const { initialInventory, availableItems } = Inventory;
    
    const { activeOrdersData, dietaryPreferences } = User;

    //Redux Actions
    const { navigate,  
            setMiscDishData, setUserData, setCart, setCurrency, clearFoodData, clearXookData,
            clearCart, storeXookData, setXookServingData, storeFoodData, setInitalInventory, updateIngrdientQuantity, storeDynamicData
    } = props;

    //Component States
    const query = useQuery();
    const source = query.get("source");
    const initialLoading = dataLoaded && !source ? false : true;
    const { kioskId } = props?.match?.params;
    const [foodDataError,setFoodDataError] = useState(false);
    const [userDataError,setUserDataError] = useState(false);
    const [loading,setLoading] = useState(initialLoading);
    const [drawerDishDetails,setDrawerDishDetails] = useState<any>({});
    const [componentsLoading,setComponentsLoading] = useState<any>([]);
    const [isDrawerOpen,toggleDrawer] = useState<boolean>();
    const [errorCode, setErrorCode] = useState<any>();

    const isAppOffline = useIsAppOffline();

    function isEmpty(obj:any) {
       return Object.keys(obj).length === 0 && obj.constructor === Object
    }

    function useQuery() {
		return new URLSearchParams(useLocation().search);
	}

    useEffect(() => {
        onPageLoad();
    },[]);

    useEffect(() => {
        if(isAppOffline) {
            setErrorCode(SPECIAL_ERRORS.NETWORK_ERROR);
            setUserDataError(true);
        }
        else if(!isAppOffline && errorCode === SPECIAL_ERRORS.NETWORK_ERROR) {
            setErrorCode(null);
            refresh();
        }
    }, [isAppOffline])

    function onPageLoad() {

        Analytics.trackPage(TRACK_PAGE_CATEGORIES.PAGE_LOAD, "Kiosk Landing");

        if(!dataLoaded) {
            getDataAndValidate();
        } else {
            //TODO: Write this more generic?
            if(source === "trackOrder") {
                setLoading(true);
                getDataAndValidate(true);
            }
        }
    }

    function refresh() {
        setFoodDataError(false);
        setUserDataError(false);
        setLoading(true);
        getDataAndValidate();
    }

    function handleErrorCodes(code:any) {
        if(errorCode === SPECIAL_ERRORS.NETWORK_ERROR) return;
        setErrorCode(code);
    }

    function getDataAndValidate(onlyPreferences:boolean = false) {

        //Have to wait for both dynamic data and cart data to be available to allocate inventory for current cart items.

        let promises = [];

        if(!onlyPreferences) {
            promises.push(getStaticData(kioskId));
            promises.push(getDynamicData(kioskId));
        }
        promises.push(getUserPreferences(kioskId))

        Promise.all(promises).then((responses:any) => {
            if(responses[0] && responses[1] && responses[2]) {
                const { recipesMap, availableItems } = responses[1];
                const { cartData } = responses[2];

                //Allocate inventory for cartItems

                if(cartData?.cartItems?.length) {
                    const { isCartValid, invalidCartItems } = validateCartItems({ cartItems:cartData.cartItems, recipesMap, availableItems });
                    const calculateOnlyFor = cartData.cartItems.filter((cartItem:any, index:any) =>  !invalidCartItems.includes(index) );
                    const { quantityRequired } = calculateInventory({ cartPayload: { cartItems:calculateOnlyFor }, recipesMap });

                    updateIngrdientQuantity( { inventoryPayload: quantityRequired, mode: INVENTORY_UPDATE_ACTION.REMOVE});

                    setCart({ isCartValid, invalidCartItems, ...cartData });
                };

                storeXookData({ dataLoaded:true });
            } 
            setLoading(false);
            if(errorCode && !isAppOffline) setErrorCode(null);
        }).catch(err => { console.log(err); setLoading(false) })
    }

    async function getStaticData(kioskId: string) {
		const response = await FoodService.getStaticData(kioskId);
		const { data, error, errorCode } = response;
		if (data) {
			const { restaurantDetails, currencySymbols, ...foodData } = data;
			storeXookData({ ...restaurantDetails, currencySymbols, xookId: kioskId });
			storeFoodData(foodData);
            HistoryService.saveRecentlyVisitedKiosk({ ...restaurantDetails, kioskId });
			return { currencySymbols };
		}
		if (error) {
            setUserDataError(true)
            handleErrorCodes(errorCode);
			return false;
		}
		return false;
	}

	async function getDynamicData(kioskId: string) {
		const response = await FoodService.getDynamicFoodData(kioskId);
		const { data, error, errorCode } = response;
		if (data) {
			const { statusData, pricingMap, availableItems, ...rest } = data;
			const { menuData, recipesMap } = rest;
			const { currencySymbol } = menuData;
			setXookServingData(statusData);
            setInitalInventory({ availableItems });
			storeDynamicData(rest);
			storeXookData({ pricingMap, currency: currencySymbol });
			return { recipesMap, availableItems };
		}
		if (error) {
            setUserDataError(true)
            handleErrorCodes(errorCode);
            return false;
		}
        return false;
	}

    async function getUserPreferences(kioskId:string) {
        const response = await UserService.getUserPreferences();
        const { data, error, errorCode } = response;
        if(data) {
            const { cartData, ...rest } = data;
            const activeKioskCartData = cartData?.[kioskId];
            setUserData(rest);
            if(activeKioskCartData) {
                return { cartData: activeKioskCartData };
            } else {
                return { cartData: {} };
            }
        }
        if(error) {
            setUserDataError(error);
            handleErrorCodes(errorCode);
            return false
        }
    }

    function goToDishPage(config:any) {
        const { brandId, dishId, mode } = config;
        navigate.push(`/kiosk/${xookId}/${brandId}/dish/${dishId}?mode=${mode}`,'forward','push');
    }

    //Get the Dish Selected count
    function getDishCount(dishId:string) {
        if(cartItems.length) {
            return cartItems.reduce((dishCount:any, item:any) => {
                if(item.dishId === dishId) {
                    dishCount += item.quantity;
                } 
                return dishCount;
            } , 0);
        }
        return 0;
    }

    function renderPage() {
        
        if(!(foodDataError || userDataError)) {
            let renderData = [];
            //Empty menu data check
            if(isEmpty(menuData)) {
                return;
            }
            const { subMenus } = menuData;
            //Empty submenus check
            if(!subMenus || !subMenus.length) {
                return;
            }
            for (const subMenuId in subMenus) {
                const subMenuData = subMenus[subMenuId];
                //Empty Submenu data check
                if(isEmpty(subMenuData)) {
                    continue;
                }
                let { name, description, imageUrl, activeDishes, inactiveDishes ,brandId } = subMenuData;
                const brandData = brandDetails?.[brandId];
                if(!brandData) {
                    return;
                }
                activeDishes = activeDishes || [];
                inactiveDishes = inactiveDishes || [];
                const combined = [...activeDishes, ...inactiveDishes];
                let subMenuRenderData = [], dishesRenderData = [];
                subMenuRenderData.push(
                    <SubMenuHead>
                        <SubMenuImage src={imageUrl} />
                        <SubMenuDetails>
                            <SubMenuTitle>{name}</SubMenuTitle>
                            <SubMenuSubtitle>{description}</SubMenuSubtitle>
                        </SubMenuDetails>
                    </SubMenuHead>
                )

                //Render SubMenu Dishes
                for(const dish of combined) {
                    const { dishId, isHero } = dish;
                    const dishDataStatic = dishDetails?.[dishId];
                    const dishDataDynamic = dishesDataDynamic?.[dishId];
                    //If all the required data for dish is available then render the dish
                    if(!(dishDataStatic && dishDataDynamic)){
                        continue;
                    }
                    const { title, summary, description:dishDescription, imageBaseUrl, imagePaths, tags } = dishDataStatic;
                    let { nextAvailableSlotId, status, offeredPrice, originalPrice } = dishDataDynamic;
                    let dishName = title.split(" ");

                    let isSoldOut;
                    let isAvailableLater;
                    let hasDiscountedPrice = typeof offeredPrice !== 'undefined' && offeredPrice !== originalPrice;

                    if(hasActiveReplenishment) {
                        isSoldOut = false; 
                        isAvailableLater = false;
                        status = DishStates.AVAILABLE
                    } else {
                        isSoldOut = status === DishStates.SOLD_OUT || status === DishStates.AVAILABLE_LATER;
                        // isAvailableLater = status === DishStates.AVAILABLE_LATER;
                    }

                    let nextAvailableTime;
                    //Next available at FLow
                    const nextAvailableAt = nextAvailableSlots?.[nextAvailableSlotId];

                    if((isAvailableLater || isSoldOut) && nextAvailableAt) {
                        const { time, day, gapValue } = nextAvailableAt;
                        if(gapValue < 100){
                            nextAvailableTime = `Available Today ${time.time}${time.meridiem}`;
                        }
                        else if(gapValue < 200){
                            nextAvailableTime = `Available Tommorow ${time.time}${time.meridiem}`;
                        }
                        else {
                            nextAvailableTime = `Available ${day}`
                        }
                    }
                    //Getting Dish Styling
                    const { background, fill, fillText, primaryText,secondaryText, secondaryFill, secondaryFillText, shadow } = DishCardColors[status];

                    //Payloads for dish Actions
                    const dishSelectPayload = { 
                        brandId,
                        dishId,
                        mode: hasActiveReplenishment ? DISH_MODES.EXPLORE : DISH_MODES.CREATE
                    }

                    const dishDrawerPayload = { brandDetails, dishDetails:dishDataStatic };

                    const dishSelectedCount = hasActiveReplenishment ? 0 : getDishCount(dishId);
                    const hero = true;

                    //Open Drawer which shows all the cart Items for the selected Dish
                    const openDrawer = (e:any) => {
                        e.stopPropagation();
                        setDrawerDishDetails(dishDrawerPayload);
                        toggleDrawer(true);
                    };

                    dishesRenderData.push(
                        <DishCard hero={hero} background={background} isAvailableLater={isAvailableLater} isSoldOut={isSoldOut} onClick={() => goToDishPage(dishSelectPayload)}  >
                            <DishImage isSoldOut={isSoldOut} hero={hero} src={`${imageBaseUrl}/${imagePaths[0]}`} shadow={shadow} />
                            <EmptySpace hero={hero} />
                            {
                                tags?.[0] ? <Tag fill={fill} color={fillText} >{tags[0]}</Tag> : <FillerElement />
                            }
                            <DishTitle hero={hero} color={primaryText} >{dishName[0]} <br /> {dishName.slice(1).join(" ")}</DishTitle>
                            <Line hero={hero} fill={secondaryFill} />
                            <DishDesc hero={hero} color={secondaryText} >{dishDescription}</DishDesc>
                            <DishFooter hero={hero} >
                                <DishPricing> 
                                    {
                                        hasDiscountedPrice ? <>
                                            <DishPrice hero={hero} color={primaryText} >{currency}{uptilTwoDecimalPlaces(offeredPrice)}</DishPrice>
                                            <DishDiscountedPrice hero={hero} color={primaryText} >
                                                {currency} {uptilTwoDecimalPlaces(originalPrice)}
                                            </DishDiscountedPrice> 
                                        </>
                                        : <DishPrice hero={hero} color={primaryText} >{currency}{uptilTwoDecimalPlaces(originalPrice)}</DishPrice>
                                    }
                                </DishPricing>
                                { ( !isSoldOut && dishSelectedCount > 0 ) &&  <DishCount id="open-modal" onClick={openDrawer} fill={secondaryFill} fillText={secondaryFillText} >{dishSelectedCount}</DishCount> }
                            </DishFooter>
                            { isSoldOut ?
                                <Overlay>
                                    <OverlayContent>
                                    {/* <NextAvailableMessage>{nextAvailableTime}</NextAvailableMessage> */}
                                    { isSoldOut ? <SoldOutMessage>SOLD OUT</SoldOutMessage> : ""}
                                    </OverlayContent>
                                </Overlay> : 
                                "" 
                            }
                        </DishCard>
                    )
                }

                subMenuRenderData.push(<Dishes>{dishesRenderData}</Dishes>)
                renderData.push(<SubMenu>{subMenuRenderData}</SubMenu>);
            }
            return renderData;
        }
        else {
            //Not Serving flow
        }

    };

    //Render Cart CTA
    function renderCart() {
        if(cartItems.length && !hasActiveReplenishment) {

            const cartPriceToShow = typeof offeredCartPrice !== 'undefined' ? offeredCartPrice : cartPrice;

            return <CartFloater onClick={() => navigate.push(`/kiosk/${xookId || kioskId}/cart`,'forward')} >
                <CartContent>
                    <CartIconWrapper>
                        <CartIcon src={bag} />
                        <CartCount>{itemsCount}</CartCount>
                    </CartIconWrapper>
                    <CartPrice>{currency} {uptilTwoDecimalPlaces(cartPriceToShow)}</CartPrice>
                </CartContent>
            </CartFloater>
        }
    }

    function renderDrawer() {

        let drawerData = [];

        if(cartItems.length && !isEmpty(drawerDishDetails)) {
            let dishItems:any = [];

            const { dishDetails } = drawerDishDetails;
            const { _id:selectedDishId, title } = dishDetails;
            let CartItems = deepCopy(cartItems);
            //Add Cart Index to the Drawer Items. Required when customizing dish.
            let cartItemsWithCartIndex = CartItems.map((cartItem:any,index:any) => {
                return { ...cartItem,cartIndex:index };
            });
            //Filter out items with the selected dish id.
            let ItemsWithSelectedDishId = cartItemsWithCartIndex.filter((cartItem:any) => {
                const { dishId } = cartItem;
                return dishId === selectedDishId
            });

            //Render Filtered out items.
            ItemsWithSelectedDishId.forEach((item:any,index:any) => {

                const { dishId, quantity, price, offeredPrice, segments, brandId, defaultRemoved, noDefaultAdded, totalCalories, cartIndex, allergens } = item;

                const isLoading = componentsLoading.includes(index);

                const customizeDish = () => {
                    const linkToCustomize = `/kiosk/${xookId}/${brandId}/dish/${dishId}?mode=${DISH_MODES.CUSTOMIZE}`;
                    const itemCustomizePayload = { 
                        cartIndex,
                        customizedSegments:segments, 
                        quantity, 
                        totalCalories,
                        totalDishPrice:price,
                    }
                    setMiscDishData(itemCustomizePayload);
                    navigate.push(linkToCustomize,'backward');
                }

                const isCartItemInvalid = invalidCartItems.includes(index + "");

                dishItems.push(<DrawerDishComponent disabled={isCartItemInvalid} >
                    <DishIndex>{index + 1}.</DishIndex>
                    <DishData>
                        {renderCustomisations({ defaultRemoved, noDefaultAdded }, allergens, dietaryPreferences)}
                        <CustomizeLink onClick={customizeDish} >Customize</CustomizeLink>
                    </DishData>
                    <DishColumn>
                        <QuantityManager disableAdd={isCartItemInvalid} value={quantity} isLoading={isLoading} incrementer={() => {updateCart(cartIndex, "INCREMENT")}} decrementer={() => {updateCart(cartIndex, "DECREMENT")}} />
                        <DrawerDishPricing>
                        { typeof offeredPrice !== 'undefined' ? 
                            <>
                                <DiscountedPrice>{currency} {uptilTwoDecimalPlaces(price)}</DiscountedPrice> 
                                &nbsp; {currency} {uptilTwoDecimalPlaces(offeredPrice)} 
                            </> : 
                            <> {currency} {uptilTwoDecimalPlaces(price)}</>
                        }
                        </DrawerDishPricing>
                    </DishColumn>
                </DrawerDishComponent>)
            })

            drawerData.push(<>
                <Row>
                    <DrawerHeader>{title}</DrawerHeader>
                    <IonIcon src={closeCircleOutline} color='#FFF' style={{'fontSize':'24px'}} onClick={() => toggleDrawer(false)} />
                </Row>
                <DrawerSubHeader>Customizations</DrawerSubHeader>
                {dishItems}
            </>)

        } else {
            drawerData.push(<Center><Header> No items </Header></Center>)
        } 

        return drawerData;
    }

    //Update Cart Item Quantity
    function createCartPayload(mode:string, index:any) {
        const { quantity, price } = cartItems[index];
        let newItem = deepCopy(cartItems[index]);
        let newQuantity = quantity;
        let newCartItems = deepCopy(cartItems);
        let newItemsCount = deepCopy(itemsCount);
        let dishPrice = quantity ? price  : 0;
        let itemPrice = price;

        switch(mode) {
            case "INCREMENT": 
                // itemPrice += dishPrice;
                newQuantity++;
                newItemsCount++;
                break;

            case "DECREMENT": 
                // itemPrice -= dishPrice;
                newQuantity--;
                newItemsCount--;
                break;
        }

        if(newQuantity < 0) {
            return;

        } else if (newQuantity === 0) {
            //If quantity is 0 set the cart Item Price as 0
            newItem.price = 0;
            newItem.quantity = newQuantity;
            newCartItems[index] = newItem;
        }
        else { 
            newItem.price = precision(itemPrice, 2);
            newItem.quantity = newQuantity;
            newCartItems[index] = newItem;
        }

        //Updating the cart Details.
        let newCartPrice = cartPrice + dishPrice;

        //Cart Payload
        return {
            cart: {
                cartPrice:precision(newCartPrice, 2),
                cartItems:newCartItems,
                itemsCount:newItemsCount,
            }
        }
    }

    async function updateCart(index:any, mode:any) {

        if(mode === "INCREMENT") {
            const newItemsCount = itemsCount + 1;
            //Check for Max Items allowed per order
            if(newItemsCount > maxItemsPerOrder) {
                //Show Error 
                setComponentsLoading((prev:any) => prev.filter((cartIndex:any) => cartIndex !== index ));
                ToastService.showToast('Max Cart Quantity Reached');
                return;
            }

            //Increment the quantity and check if it's valid.
            const cartItemWithNewQuantity = { ...cartItems[index], quantity : 1 };

            const { isCartValid } = validateCartItems({ cartItems: [ cartItemWithNewQuantity ], availableItems, recipesMap });

            if(!isCartValid) {
                setComponentsLoading((prev:any) => prev.filter((cartIndex:any) => cartIndex !== index ));
                ToastService.showToast(cartAddDisabledError);
                return;
            }

        }

        const cartPayload = createCartPayload(mode, index);
        setComponentsLoading((prev:any) => [ ...prev, index]);
        const response = await OrderService.addToCart(cartPayload, xookId);
        const { data, error } = response;
        if(data) {

            //Set updatedCart
            const { newCart, discardedCart } = data;

            let showDiscardedItemsError = false;

            if(discardedCart?.cartItems?.length) {
                //Show Error
                showDiscardedItemsError = true;
            }

            //Validate Cart on every change
            const { isCartValid, invalidCartItems } = validateCartItems({ cartItems: newCart.cartItems, recipesMap, availableItems:initialInventory });
            //Filter out valid items
            const calculateOnlyFor = newCart.cartItems.filter((cartItem:any, index:any) =>  !invalidCartItems.includes(index + "") );
            //Calculate inventory for only valid items.
            const { quantityRequired } = calculateInventory({ cartPayload: { cartItems:calculateOnlyFor }, recipesMap });
            //Update inventory accordingly
            updateIngrdientQuantity({ inventoryPayload: quantityRequired, mode: INVENTORY_UPDATE_ACTION.REMOVE_FROM_INITIAL });

            let cartUpdatedPayload = { ...newCart, invalidCartItems, isCartValid, showDiscardedItemsError, discardedCart };
            setCart(cartUpdatedPayload);
        }
        if(error) {
            ToastService.showToast('Something Went Wrong');
        }

        setComponentsLoading((prev:any) => prev.filter((cartIndex:any) => cartIndex !== index ));
    }

    function goToAccountPage() {
       navigate.push('/account');
    }

    function goBackToSelectPage() {
        clearFoodData();
        clearXookData();
        clearCart();
        navigate.push('/');
    }

    //Sort the active orders by latest arriving and set the link to that order.
    function renderActiveOrderLink(kioskId:string) {
        if(!activeOrdersData) {
            return;
        }
        const restaurantActiveOrders = activeOrdersData[kioskId];
        if(!restaurantActiveOrders) {
            return;
        }
        const { activeOrderIds, activeOrderText } = restaurantActiveOrders;
        if(activeOrderIds && !isEmpty(activeOrderIds)) {
            const upcomingactiveOrder = Object.keys(activeOrderIds)[0];

            const travelToTrackOrder = () => {
                navigate.push(`/kiosk/${kioskId}/order/track/${upcomingactiveOrder}`, 'forward');
            }

            return  <SecondaryCTA src={cooking} onClick={travelToTrackOrder} > 
                    <ActiveOrderText>
                        <IonIcon src={logoIonic} />
                        {activeOrderText}
                    </ActiveOrderText>
                    <TrackOrderText>
                        TRACK ORDER
                        <IonIcon src={chevronForwardOutline} />
                    </TrackOrderText>
                </SecondaryCTA>
        }
    }

    return (
        <Page padding="0 0 1rem 0" className='no-scrollbar' >
            <PageHeader>
                <HeaderSegment1 onClick={goBackToSelectPage}>
                    <RestaurantDetails >
                        {
                            !loading && !(foodDataError ) ? 
                            <>
                                <RestaurantLocation>{xookLocation}</RestaurantLocation>
                                <SmallLine />
                            </> : 
                            ""
                        }
                        
                        <RestaurantId>Kiosk ID : {xookId?.length ? xookId : kioskId}</RestaurantId>
                    </RestaurantDetails>
                </HeaderSegment1>
                <HeaderSegment2>
                <Account src={personCircleOutline} onClick={goToAccountPage} />
                </HeaderSegment2>
            </PageHeader>
            { !loading && renderActiveOrderLink(kioskId) }
            { hasActiveReplenishment ? <ReplenishmentMessage >We are refilling the kiosk,<br /> we will start serving shortly.  </ReplenishmentMessage> : "" }
            {
                !(foodDataError || userDataError) && !loading  &&
                <PromoBanner />
            }
            {
                (!(foodDataError || userDataError) && !loading) && 
                <MenuContainer>
                    {renderPage()}
                    {renderCart()}
                    {/* <Drawer isOpen={isDrawerOpen} onClose={() => toggleDrawer(false)} >{renderDrawer()}</Drawer> */}
                </MenuContainer>
            }
            {
                (foodDataError || userDataError) && !loading &&
                <TechnicalError code={errorCode} />
            }
            {
                componentsLoading.length ? <ModalOverlay /> : ""
            }
            {
                loading && 
                <Center>
                    <IonSpinner name='dots' color={"#F2F2F2"} ></IonSpinner>
                </Center>
            }
        </Page>
    )
}

//Redux mapping
const mapStateToProps = (state: any) => {
    const { Xook, Food, User, Cart, Inventory } = state;
    return { Xook, Food, User, Cart, Inventory };
};
  
const mapDispatchToProps = (dispatch: any) => ({
    ...bindActionCreators({
        ...FoodActions, ...XookActions, setMiscDishData, setCart, clearCart, setUserData, setInitalInventory, updateIngrdientQuantity
    }, dispatch)
});

export default connect(mapStateToProps,mapDispatchToProps)(withNav(MachineLanding));